// router.js 定义应用路由

import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { BasicLayout, UserLayout, BlankLayout } from '@/layouts';

// 按照 Layout 分组路由：配合routerConfig进行配置
// 请按实际项目需求选择修改对应的Layout并调整布局
const Routers = () => {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Switch>
                <Route path="/user" component={UserLayout} />
                <Route path="/sc" component={BlankLayout} />
                <Route path="/" component={BasicLayout} />
            </Switch>
        </Router>
    );
};

export default Routers;
